module.exports = __webpack_public_path__ + "img/bem-vindo.4e4b1cec.png";